// extracted by mini-css-extract-plugin
export default {"root":"Loader_root--O5O","overlay":"Loader_overlay--q8Z","icon":"Loader_icon--tUc","spin":"Loader_spin--ltM"};